/**
 * Мобильная навигация по периодам на странице «История».
 */
const ACTIVE_CLASS = "section-history__era-nav-item--active";

function setActiveItem(nav, activeId) {
  const items = nav.querySelectorAll("[data-history-era]");
  items.forEach((btn) => {
    const id = btn.getAttribute("data-history-era");
    const isActive = id === activeId;
    btn.classList.toggle(ACTIVE_CLASS, isActive);
    btn.toggleAttribute("aria-current", isActive);
  });
}

function scrollSpyMarkerPx(sampleEraEl) {
  const doc = sampleEraEl?.ownerDocument || document;
  const header = doc.querySelector(".header");
  const headerH = header ? header.getBoundingClientRect().height : 0;
  let scrollMarginTop = 0;
  if (sampleEraEl) {
    const raw = doc.defaultView?.getComputedStyle(sampleEraEl).scrollMarginTop;
    scrollMarginTop = Number.parseFloat(raw) || 0;
  }
  /**
   * Порог должен быть не ниже, чем фактический верх якоря после scrollIntoView:
   * у колонок года задан scroll-margin-top (см. _history.scss), он часто больше высоты хедера.
   */
  return Math.max(headerH + 8, scrollMarginTop, 0) + 2;
}

export function initHistoryEraNav(root = document) {
  const view = root.defaultView;
  const nav = root.querySelector(".section-history__era-nav");
  if (!nav || !view) return;

  const items = [...nav.querySelectorAll("[data-history-era]")];
  const eraElements = items
    .map((btn) => root.getElementById(btn.getAttribute("data-history-era") || ""))
    .filter(Boolean);

  if (!eraElements.length) return;

  /** Пока идёт плавный скролл по клику — не трогаем подсветку (иначе «перебираются» все эпохи по дороге). */
  let programmaticLockId = null;
  let lockReleaseTimer = 0;
  let lockScrollEndHandler = null;

  const teardownLockRelease = () => {
    if (lockScrollEndHandler) {
      view.removeEventListener("scrollend", lockScrollEndHandler);
      lockScrollEndHandler = null;
    }
    if (lockReleaseTimer) {
      view.clearTimeout(lockReleaseTimer);
      lockReleaseTimer = 0;
    }
  };

  const finishProgrammaticLock = () => {
    teardownLockRelease();
    programmaticLockId = null;
    syncActiveFromScroll();
  };

  const scheduleLockRelease = () => {
    teardownLockRelease();
    lockScrollEndHandler = finishProgrammaticLock;
    view.addEventListener("scrollend", lockScrollEndHandler, { passive: true });
    lockReleaseTimer = view.setTimeout(finishProgrammaticLock, 1000);
  };

  function syncActiveFromScroll() {
    if (programmaticLockId !== null) return;

    const marker = scrollSpyMarkerPx(eraElements[0]);
    let activeId = eraElements[0]?.id;
    if (!activeId) return;

    for (const el of eraElements) {
      const top = el.getBoundingClientRect().top;
      if (top <= marker) {
        activeId = el.id;
      }
    }

    setActiveItem(nav, activeId);
  }

  let scrollRaf = 0;
  const onScrollOrResize = () => {
    if (scrollRaf) return;
    scrollRaf = view.requestAnimationFrame(() => {
      scrollRaf = 0;
      syncActiveFromScroll();
    });
  };

  view.addEventListener("scroll", onScrollOrResize, { passive: true });
  view.addEventListener("resize", onScrollOrResize);

  view.requestAnimationFrame(() => syncActiveFromScroll());

  nav.addEventListener("click", (event) => {
    const control = event.target.closest("[data-history-era]");
    if (!control || !nav.contains(control)) return;

    const id = control.getAttribute("data-history-era");
    if (!id) return;

    const target = root.getElementById(id);
    if (!target) return;

    teardownLockRelease();
    programmaticLockId = id;
    setActiveItem(nav, id);
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    scheduleLockRelease();
  });
}
